import ERROR_CODE_MESSAGE from 'src/assets/locales/en-us/error-codes-messages.json';
import { Toast } from 'src/types';

interface DisplayedError {
    code: number;
    time: number;
}

const displayedErrors: DisplayedError[] = [];
const noDuplicationErrorCodes: number[] = [30001, 30007, 30009];

export function errorHandler(error: any) {
    let parsedError: Toast | undefined = undefined;

    if (error?.response !== undefined) {
        const errorCode = error?.response?.data?.code;
        const errorMessage =
            ERROR_CODE_MESSAGE[errorCode] ??
            error?.response?.data?.msg ??
            error?.response?.data?.error;
        parsedError = {
            id: new Date().getTime().toString(),
            title: errorMessage,
            type: 'error',
        };

        //stop duplication
        if (noDuplicationErrorCodes.includes(errorCode)) {
            const displayedError = displayedErrors.find(
                (e: DisplayedError) => e.code === errorCode,
            );
            if (displayedError) {
                if (new Date().getTime() - displayedError.time < 15000) {
                    return;
                }
            } else {
                displayedErrors.push({ code: errorCode, time: Number(parsedError.id) });
            }
        }
    } else {
        parsedError = {
            id: new Date().getTime().toString(),
            title: 'application_down',
            type: 'error',
        };
    }

    return parsedError;
}
